<template>
  <ValidationObserver
    ref="customFieldObserver"
    v-slot="{ valid, dirty }" >
    <b-modal
      id="create-contact-modal"
      ref="createContactModal"
      v-model="modalVisible"
      modal-class="create-contact-modal"
      centered
      :hide-header-close="true"
      size="md"
      @hidden="modalHidden" >
      <template slot="modal-title">
        Add new contact
      </template>
      <template slot="default">
        <div class="">
          <b-form-group>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              name="Name" >
              <label
                for="create-contact-modal-name"
                class="col-12">
                Name
              </label>
              <b-form-input
                id="create-contact-modal-name"
                v-model="contactName"
                autocomplete="off"
                autofocus
                class="sb2-bordered sb2-hoverable sb2-focusable"
                type="text"
                placeholder="Full name" />
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <b-form-group>
            <ValidationProvider
              v-slot="{ errors, failedRules }"
              ref="phoneValidatorProvider"
              name="Phone"
              mode="passive"
              rules="required|phone" >
              <label
                for="create-contact-modal-phone"
                class="col-12">
                Phone
              </label>
              <div class="relative">
                <b-form-input
                  id="create-contact-modal-phone"
                  ref="contactPhoneRef"
                  v-model="contactPhone"
                  autocomplete="off"
                  class="sb2-bordered sb2-hoverable sb2-focusable"
                  type="text"
                  :placeholder="examples.international"
                  @input="testIfPhoneInSystem" />
                <Spinner
                  v-if="checkingNumberExistance"
                  :size="16"
                  :thickness="2"
                  class="small checking-number" />
              </div>
              <!-- <div
                v-if="!valid.phone"
                class="error-wrapper">
                <div
                  class="error-message">
                  <SBIcon
                    :icon="SBIconList.ERROR"
                    color="#ff5b61"
                    :size="12"/>
                  <span class="margin-x-5">
                    Phone format is wrong
                  </span>
                  <SBIcon
                    id="create-contact-modal-phone-error"
                    :icon="SBIconList.INFO_INVERSE"
                    color="#ff5b61"
                    :size="12"/>
                </div>
                <b-popover
                  target="create-contact-modal-phone-error"
                  triggers="hover"
                  placement="bottom"
                  custom-class="no-pointer-events" >
                  <h1 class="error-color">Phone number format is wrong</h1>
                  <p>You must use a phone number in full international
                    format that includes a plus sign (+)
                    followed by the country code, city
                    code, and local phone number.</p>
                  <p>For example, if a contact in the United
                    Kingdom (country code "44") has the
                    area code "020" and phone number
                    "XXX-XXXX", you'd enter
                    +44 020 XXX XXXX.</p>
                </b-popover>
              </div> -->
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>{{ errors[0] }} </span>
                <template v-if="failedRules.phone">
                  <SBIcon
                    id="create-contact-modal-phone-error"
                    class="ml-1"
                    :icon="SBIconList.INFO_INVERSE"
                    color="#ff5b61"
                    :size="12"/>
                  <b-popover
                    target="create-contact-modal-phone-error"
                    triggers="hover"
                    placement="bottom"
                    custom-class="no-pointer-events" >
                    <h1 class="error-color">Phone number format is wrong</h1>
                    <p class="strong">Supported national format ({{ userRegion }})</p>
                    <p>A phone number in {{ userRegion }} national format without country code and a plus sign (+).</p>
                    <p><i>Example {{ examples.national }}</i></p>
                    <p class="strong">Supported international format (E.164)</p>
                    <p>A phone number in full international format that includes a plus sign (+).</p>
                    <p><i>Example {{ examples.international }}</i></p>
                  </b-popover>
                </template>
              </div>
              <div
                v-if="!errors[0] && contactExists"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Phone number already exists</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <div
            v-if="customErrorMessage"
            class="error-wrapper">
            <div
              class="error-message">
              <SBIcon
                :icon="SBIconList.ERROR"
                color="#ff5b61"
                :size="12"/>
              <span class="margin-x-5">
                {{ customErrorMessage }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template slot="modal-footer">
        <b-button
          :disabled="creating"
          @click="hide" >
          <span>Cancel</span>
        </b-button>
        <SB2Button
          variant="primary"
          :disabled="creating || !valid || !dirty || (contactExists !== false)"
          :loading="creating"
          @click="createContact">
          Create
        </SB2Button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import examples from 'libphonenumber-js/examples.mobile';
import { position } from 'caret-pos';
import { AsYouType, getExampleNumber, parsePhoneNumber } from 'libphonenumber-js/max';

import { debounce } from 'debounce';
import Multiselect from 'vue-multiselect';
import SBIcon from '../../../common/Icon';
import SBIconList from '../../../../helpers/lists/sb-icon-list';
import SBColors from '../../../../helpers/lists/colors';
import Spinner from '../../../common/Spinner';
import SB2Button from '../../../common/SB2Button';

// const branchFilterAllBranchesItem = {
//   id: '',
//   name: 'All Numbers',
//   logo: '',
//   displayName: 'All Numbers',
//   iconIndex: null,
// };

export default {
  name: 'CreateContactModal',
  components: {
    SBIcon,
    Multiselect,
    SB2Button,
    Spinner,
  },
  props: {
    preselectBusinessId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      SBIconList,
      SBColors,
      modalVisible: false,
      creating: false,
      contactName: '',
      contactPhone: '',
      contactPhoneInternational: null,
      customErrorMessage: '',
      contactExists: null,
      checkingNumberExistance: false,
      preventSearchContactValueChange: false,
      examples: {
        national: '',
        international: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      vuexBranches: 'organisation/currentOrganisationBusinesses',
      userRegion: 'user/region',
    }),
    // shorthand
    organisationId() {
      return this.$route.params.organisationId;
    },
    // list of branches with added displayName
    branches() {
      return this.vuexBranches.map((b, index) => ({
        id: b.id,
        name: b.name,
        logo: b.logo,
        displayName: `${b.name} (${b.phone})`,
        iconIndex: index % 10,
      }));
    },
    branchFilterItemList() {
      // return [branchFilterAllBranchesItem, ...this.branches];
      return this.branches;
    },
  },
  watch: {
    contactPhone() {
      if (!this.$refs.contactPhoneRef) {
        return;
      }
      const startsWith00 = /^00/.test(this.contactPhone);
      const tempValue = this.contactPhone.replace(/^00/, '+');
      if (this.preventSearchContactValueChange) {
        this.preventSearchContactValueChange = false;
        return;
      }
      this.caretPosition = position(this.$refs.contactPhoneRef.$el).pos;
      const currentInput = this.contactPhone.toString();
      const uptoCarretNoSpace =
        currentInput
          .substring(0, this.caretPosition)
          .replaceAll(' ', '')
          .split('')
          .join('\\s*')
          .replaceAll('\\\\', '\\')
          .replaceAll('+', '\\+');

      const asYouTypeInstance = new AsYouType(this.userRegion);
      asYouTypeInstance.input(tempValue);
      const outputValue = startsWith00 ? `00 ${asYouTypeInstance.formattedOutput.replace(/^\+/, '')}` : asYouTypeInstance.formattedOutput;
      this.contactPhone = outputValue;
      this.contactPhoneInternational = asYouTypeInstance.getNumber() ? asYouTypeInstance.getNumber().formatInternational() : null;
      this.preventSearchContactValueChange = true;
      setTimeout(() => {
        this.preventSearchContactValueChange = false;
      });

      this.$nextTick(() => {
        const matchCarretPos = this.contactPhone.match(uptoCarretNoSpace);
        if (matchCarretPos) {
          this.$refs.contactPhoneRef.$el.setSelectionRange(matchCarretPos[0].length, matchCarretPos[0].length);
        }
      });
    },
  },
  mounted() {
    this.generateExampleNumber();
  },
  methods: {
    ...mapActions({
      vuexCreateContact: 'contact/createContact',
      getContactsForOrganisation: 'contact/getContactsForOrganisation',
    }),
    getBusinessById(businessId) {
      return this.branches.find(b => b.id === businessId) || '';
    },
    generateExampleNumber() {
      let exampleNumber = '';
      try {
        exampleNumber = getExampleNumber(this.userRegion, examples);
        this.examples = {
          national: exampleNumber.formatNational(),
          international: exampleNumber.formatInternational(),
        };
      } catch {}
      return exampleNumber;
    },
    show() {
      // if we get preselectedBusinessId prop,
      // find that business and set it as current value
      // console.log('set branch to ', this.preselectBusinessId, 'xxx', this.getBusinessById(this.preselectBusinessId));
      this.modalVisible = true;
    },
    hide() {
      this.creating = false;
      this.modalVisible = false;
    },
    reset() {
      // reset values
      this.contactName = '';
      this.contactPhone = '';
      this.contactExists = null;
      this.customErrorMessage = '';
    },
    createContact() {
      const payload = {
        data: {
          name: this.contactName,
          phone: this.contactPhoneInternational,
        },
        organisationId: this.organisationId,
      };
      this.creating = true;
      this.vuexCreateContact(payload)
        .then(
          (response) => {
            // contact was created, response is {contact: {...}, message: "Contact has been successfully created."}
            this.$emit('contact-create-success', response.data.contact);
          },
          (response) => {
            // if modal is open, show error message under phone number
            const errorMessage = (response.data && response.data.message) ? response.data.message : 'Contact was not created. Please try again.';
            if (this.modalVisible) {
              this.customErrorMessage = errorMessage;
            } else {
              this.$emit('contact-create-error', errorMessage);
            }
          },
        )
        .finally(() => {
          this.creating = false;
        });
    },
    modalHidden() {
      this.reset();
    },
    testIfPhoneInSystem: debounce(function f() {
      this.contactExists = null;
      // Only make the test if field is a valid number
      this.$refs.phoneValidatorProvider.validate()
        .then(() => {
          if (this.$refs.phoneValidatorProvider.flags.valid) {
            this.checkingNumberExistance = true;
            const parsedPhone = parsePhoneNumber(this.contactPhone, this.userRegion).formatInternational().replace(/\s/g, '');
            this.getContactsForOrganisation({
              organisationId: this.organisationId,
              data: {
                search_query: parsedPhone,
              },
            }).then((response) => {
              if (response.data.data.find(contact => contact.phone === parsedPhone)) {
                this.contactExists = true;
              } else {
                this.contactExists = false;
              }
            }).catch((error) => {

            }).finally(() => {
              this.checkingNumberExistance = false;
            });
          }
        });
    }, 500),
  },
};
</script>
<style lang="scss" scoped>
.error-wrapper {
  margin-top: 5px;

  .error-message {
    display: inline-flex;
    align-items: center;
    color: #ff5b61;
    padding: 8px 0;
    font-size: 14px;
  }

  .margin-x-5 {
    margin: 0 5px;
  }
}

.checking-number {
  position: absolute;
  top: 8px;
  right: 8px;
  left: unset;
}

// override formset spacing
.create-contact-modal {
  .form-group {
    margin-bottom: 16px !important;

    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}
// style multiselect
::v-deep .multiselect {
  // main displayed option
  .multiselect__single {
    display: flex;
    align-items: center;

    .multiselect-icon {
      min-width: 18px;
      display: inline-flex;
      align-items: center;
      justify-content: start;
      font-size: 12px !important;
      // margin-right: 5px;
    }
  }

  // option in dropdown list
  .multiselect__content-wrapper .multiselect__content .multiselect__element span.multiselect__option
  {
    display: flex;
    height: 32px;
    align-items: center;

    span.multiselect-icon {
      display: inline-flex;
      align-items: center;
      justify-content: start;
      height: 30px;
      min-width: 18px;
      font-size: 12px !important;
      // margin-right: 5px;
    }
    span.multiselect-check {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 10px;
    }

    // multiselect - active (selected) option in list
    &.multiselect__option--selected,
    &.multiselect__option--selected {
      // color: #2680eb !important;
      background-color: #fff !important;
    }

    // multiselect: hover/highlight option
    &.multiselect__option--highlight,
    &.multiselect__option--highlight {
      background-color: $hover !important;
    }
  }
}

</style>
